<div class="row g-0" [ngClass]=" (router.isActive('/cinejoy/premiere/archive', false) || router.isActive('/cinejoy/premiere/lineup', false)) ? 'spotlight-background' : '' " >
    <div class="" fxFlex=19.5 fxFlex.lt-md=100>
        <app-sidebar [primaryNavTemplate]="primaryNav" (secondarySideNavStatus)=updateSecondarySideNavStatus($event) ></app-sidebar>
        <ng-template #primaryNav>
            <div class="sidenav-secondary font-poppins-regular" style="display: inline-block;">
                <ul>
                    <li><a [routerLink]="'upcoming'" routerLinkActive="active" style="width: 160px;">Upcoming&nbsp;</a></li>
                    <li *ngIf="!router.isActive('/premierepage', false)"><a [routerLink]="['lineup']" routerLinkActive="active" style="width: 160px;">LineUp</a></li>
                    <li ><a href="cinejoy/group-share-info-page">Group Sharing</a></li>
                    <li ><a href="cinejoy/featured-guests">Featured Guests</a></li>
                    <li *ngIf="router.isActive('/premierepage', false)"><a [routerLink]="['premierepage']" routerLinkActive="active" style="width: 160px;">LineUp</a></li>
                </ul>
            </div>
          </ng-template>

    </div>
    <div fxFlex=80.5 fxFlex.lt-md=100 class="spotlight-main-section" [ngClass]="{'isSecondarySideNavOpen': isSecondarySideNavOpen}">
        <div [@routeAnimations]="prepareRoute(outlet)">
            <router-outlet #outlet="outlet"></router-outlet>
        </div>
    </div>

</div>